export const rules = {
    partner_clinic_id: [
        { required: true, message: 'Пожалуйста, выберите партнёрскую клинику', trigger: 'blur' },
    ],
};
